import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import logo from '../img/logo/AA_LOGO.png';
import logo1 from '../img/logo/AA_LOGO.png';

const Nav = () => {
  const [navbarBackground, setNavbarBackground] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For toggle
  const location = useLocation(); // Get current location

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setNavbarBackground(true);
      } else {
        setNavbarBackground(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar state
  };

  return (
    <>
      {/* Navbar Header */}
      <header className="init">
        <div className={`navbar-default-white navbar-fixed-top ${navbarBackground ? 'navbar-scrolled' : ''}`}>
          <div className="container-fluid">
            <div className="row p-3-vh align-items-center">
              {/* Logo and Text */}
              <Link className="logo centered d-flex align-items-center" to="/">
                <img className="h-150 init" alt="logo" src={logo} />
                <img className="h-150 show" alt="logo" src={logo1} />
                {/* <div className="ml-3 text-white">
                  <Link to="/" className="text-white text-decoration-none">
                    <h1 className="m-0 fontsmall">AA APPLICATIONS</h1>
                    <p className="m-0 fontmini" >Adaptive Applications On Demand</p>
                  </Link>
                </div> */}
              </Link>
              {/* Main Menu */}
              <div className="white menu-init" id="main-menu">
                <nav id="menu-right">
                  <ul>
                    <li>
                      <Link
                        to="/"
                        className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/who-we-are"
                        className={`nav-link ${location.pathname === '/who-we-are' ? 'active-link' : ''}`}
                      >
                        Who we are
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/what-we-do"
                        className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
                      >
                        What we do
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact"
                        className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
                      >
                        Contact
                      </Link>
                    </li>
                    {/* Social Media Icons */}
                    <li className="icons-menu">
                      <Link to="https://x.com/applications_it" target='_blank'><span className="ti-twitter"></span></Link>
                    </li>
                    <li className="icons-menu">
                      <Link to="https://www.linkedin.com/feed/?trk=onboarding-landing" target="_blank" rel="noopener noreferrer">
                        <span className="ti-linkedin"></span>
                      </Link>
                    </li>
                    <li className="icons-menu">
                      <Link to="https://www.instagram.com/appli_cation123/"  target='_blank'><span className="ti-instagram"></span></Link>
                    </li>
                    <li className="icons-menu">
                      <Link to="https://www.youtube.com/feed/you" target='_blank'><span className="ti-youtube"></span></Link>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* Sidebar Toggle Button for Large Screens */}
              <div className="menu-right centered d-none d-md-block">
                <ul className="iconright">
                  <li>
                    <div onClick={toggleSidebar} className="toggle-button">
                      <span className="ti-menu"></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Sidebar for Large Screens */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-content">
          <ul>
            <li>
              <Link
                to="/"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/who-we-are"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className={`nav-link ${location.pathname === '/who-we-are' ? 'active-link' : ''}`}
              >
                Who we are
              </Link>
            </li>
            <li>
              <Link
                to="/what-we-do"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
              >
                What we do
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
                className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Sidebar and Active Link CSS */}
      <style jsx>{`
        .sidebar {
          position: fixed;
          top: 8%;
          right: -250px; /* Start off-screen */
          width: 250px;
          height: 100%;
          background-color: #333;
          transition: right 0.3s ease-in-out; /* Smooth transition */
          z-index: 1000; /* Ensure it stays on top */
        }

        .sidebar.open {
          right: 0; /* Slide in */
        }

        .sidebar-content ul {
          padding: 0;
          list-style: none;
          margin: 0;
        }

        .sidebar-content ul li {
          padding: 15px 20px;
          border-bottom: 1px solid #444;
        }

        .sidebar-content ul li a {
          color: white;
          text-decoration: none;
        }

        .toggle-button {
          cursor: pointer;
        }

        /* Active link color */
        .active-link {
              color: #7cd1e6 !important; /* Set active link color to red */
        }

        /* Show toggle button and sidebar on larger screens */
        @media (min-width: 1200px) {
          .sidebar {
            display: none; /* Hide sidebar */
          }

          .toggle-button {
            display: block; /* Show toggle button */
          }
        }
      `}</style>
    </>
  );
};

export default Nav;
